import { InjectionToken } from '@angular/core';

export const SIGNALR_HUB_PATH = new InjectionToken<string>('signalrHubPath');
